import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axiosInstance from '../api';

/**
 * Self-service change-password form (Settings → Security, and the forced-change screen).
 * Posts /account/change-password (verifies the current password server-side).
 */
function ChangePassword({ forced = false, onSuccess }) {
  const { t } = useTranslation();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setErr(''); setMsg('');
    if (next.length < 8) { setErr(t('ChangePassword.errMinLength')); return; }
    if (next !== confirm) { setErr(t('ChangePassword.errMismatch')); return; }
    setBusy(true);
    try {
      await axiosInstance.post('/account/change-password', { currentPassword: current, newPassword: next });
      setMsg(t('ChangePassword.successUpdated'));
      setCurrent(''); setNext(''); setConfirm('');
      if (onSuccess) onSuccess();
    } catch (e2) {
      setErr(e2.response?.data?.error || t('ChangePassword.errGeneric'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="settings-group">
      {!forced && <h3 style={{ textAlign: 'left' }}>{t('ChangePassword.heading')}</h3>}
      <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 380 }}>
        <div className="form-group">
          <label>{forced ? t('ChangePassword.labelCurrentTemp') : t('ChangePassword.labelCurrent')}</label>
          <input type="password" value={current} onChange={e => setCurrent(e.target.value)}
            required autoComplete="current-password" placeholder={t('ChangePassword.placeholderCurrent')} />
        </div>
        <div className="form-group">
          <label>{t('ChangePassword.labelNew')}</label>
          <input type="password" value={next} onChange={e => setNext(e.target.value)}
            required autoComplete="new-password" placeholder={t('ChangePassword.placeholderNew')} />
        </div>
        <div className="form-group">
          <label>{t('ChangePassword.labelConfirm')}</label>
          <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
            required autoComplete="new-password" placeholder={t('ChangePassword.placeholderConfirm')} />
        </div>
        {err && <div style={{ padding: '0.5rem 0.75rem', borderRadius: 6, fontSize: '0.8125rem', background: '#fee2e2', color: '#dc2626' }}>{err}</div>}
        {msg && <div style={{ padding: '0.5rem 0.75rem', borderRadius: 6, fontSize: '0.8125rem', background: '#d1fae5', color: '#065f46' }}>{msg}</div>}
        <button type="submit" className="primary-btn" disabled={busy} style={{ width: 'fit-content' }}>
          {busy ? t('ChangePassword.btnUpdating') : <><i className="fas fa-key" /> {t('ChangePassword.btnUpdate')}</>}
        </button>
      </form>
    </div>
  );
}

export default ChangePassword;
